






























import { Component, Vue } from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import 'firebase/firebase-firestore';
import { getCurrentUser } from '@/services/auth';

export type LogFields = {
  [key: string]: {
    label: string;
    formatter?: (value: string) => string;
  };
};

export const parseEnum = (enumString: string) => enumString.split('.')[1];

export const parseBoolean = (value: string) => (value ? 'Yes' : 'No');

function convertDate(dateString: string) {
  const date = new Date(dateString);
  return (
    date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
  );
}

export const STARTING_FIELDS: LogFields = {
  date: {
    label: 'Date',
    formatter: convertDate
  },
  hospital: {
    label: 'Hospital'
  },
  age: {
    label: 'Age'
  },
  gender: {
    label: 'Gender',
    formatter: parseEnum
  },
  clinicalProblem: {
    label: 'Clinical Problem'
  }
};

export const TRAILING_FIELDS: LogFields = {
  supervisingJunior: {
    label: 'Supervising junior?',
    formatter: parseBoolean
  },
  comments: {
    label: 'Comments'
  }
};

@Component
export default class LogsList extends Vue {
  public logs: { [key: string]: string }[] = [];

  public getTitle(): string {
    throw new Error('`getTitle()` is not implemented');
  }

  public getLogFields(): LogFields {
    return {
      ...STARTING_FIELDS,
      ...this.getSpecificFields(),
      ...TRAILING_FIELDS
    };
  }

  protected getSpecificFields(): LogFields {
    throw new Error('`getSpecificFields()` is not implemented');
  }

  protected getCollectionName(): string {
    throw new Error('`getCollectionName()` is not implemented');
  }

  async created() {
    const user = await getCurrentUser();

    if (user === null) {
      throw new Error('User is null');
    }

    const firebaseLogs = await firebase
      .firestore()
      .collection(this.getCollectionName())
      .where('user', '==', user.uid)
      .orderBy('date', 'desc')
      .get();

    this.logs.push(
      ...firebaseLogs.docs.map(d => {
        const obj: { [key: string]: string } = {};

        for (const key in this.getLogFields()) {
          const originalValue = d.data()[key] as string;
          const formatter = this.getLogFields()[key].formatter;

          if (formatter !== undefined) {
            obj[key] = formatter(originalValue);
          } else {
            obj[key] = originalValue;
          }
        }

        return obj;
      })
    );
  }
}
